module.exports = __webpack_public_path__ + "static/media/cart-arrow-down.c0dcd8a7.svg";